import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { UserDataService } from './user-data.service';

@Injectable({
  providedIn: 'root'
})
export class GuardiaLoggataService {

  constructor(
    private router: Router,
    private userDataService: UserDataService
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return (this.userDataService.tipoUtente == "guardiapesca" || this.userDataService.tipoUtente == "guardiapesca_provincia") && !!this.userDataService.token;
  }
}

export const GuardiaLoggataGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(GuardiaLoggataService).canActivate(next, state);
}